import { ConfigService } from './../cart-process/config.service';
import { Component, ElementRef, OnInit } from '@angular/core';
import { SubmitOrderService } from '../order-fulfillment/submit-order.service';
import { LeadsSupportService } from '../customer-offer/auth/leads-support.service';
import { MsisdnHelperService } from '../utils/services/msisdn-helper.service';
import { BrandTypeEnum } from '../models/cartDetails/brand-type.enum';
import { NotificationProviderService, NotificationProviderTypeEnum } from '../external-interfaces/notification-provider.service';

@Component({
  selector: 'page-error-view',
  templateUrl: './page-error-view.component.html',
})
export class PageErrorViewComponent implements OnInit {

  public header: string;
  public description: string;
  public helpMessage: string;
  public buttonUrl: string;
  public buttonMessage: string;
  public isVirginBrand: boolean;
  public themeResourcePath: string = window['themeResourcePath'];

  constructor(
    private elementRef: ElementRef,
    private submitOrderService: SubmitOrderService,
    private leadsSupportService: LeadsSupportService,
    private msisdnHelperService: MsisdnHelperService,
    private notificationProvider: NotificationProviderService
  ) {
    this.header = this.elementRef.nativeElement.getAttribute('header');
    this.description = this.elementRef.nativeElement.getAttribute('description');
    this.helpMessage = this.elementRef.nativeElement.getAttribute('helpMessage');
    this.buttonUrl = this.elementRef.nativeElement.getAttribute('buttonUrl');
    this.buttonMessage = this.elementRef.nativeElement.getAttribute('buttonMessage');

    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.CONFIG,
      (config: ConfigService) => {
        if (config) {
          this.isVirginBrand = config.brand === BrandTypeEnum.VIRGIN;
        }
      }
    );
  }

  ngOnInit() {
    const formData: any[] = this.submitOrderService.storeFormData().get();

    const formItem = formData && formData.find(({name}) => name === 'customerPhone');

    const lastCartStep = this.submitOrderService.storeCartStep().get();

    if (formItem && lastCartStep == 3) {
      this.showModal(formItem.value);
    }
  }

  private showModal(phoneNumber: string) {
    const msisdn = this.msisdnHelperService.unformatMsisdn(phoneNumber);

    this.leadsSupportService.startLeads({msisdn});
  }
}
